import React from "react";
import "./Comments.css";
import {RESTComment} from "../services/types";
import Comment from "./Comment";

interface CommentsProps {
    comments : RESTComment[];
    onCommentDeleted?: () => void;
}

const Comments:React.FC<CommentsProps> = ( {comments, onCommentDeleted} ) => {

    return (
        <ul className={"Comments"}>
            {
                comments.map((comment => {
                    return (
                        <Comment 
                            key={comment.id} 
                            comment={comment}
                            onDeleted={onCommentDeleted}
                        />
                    );
                }))
            }
        </ul>
    )
}

export default Comments;